var _rect, _path, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBrokenLinkWithBg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 4,
    fill: "#E7F5EF"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4851_69491",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 6,
    width: 20,
    height: 20
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.5 6.5H25.5V25.5H6.5V6.5Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4851_69491)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.927 23.18C11.7938 24.3132 9.95646 24.3132 8.82318 23.18C7.68994 22.0467 7.68994 20.2093 8.82318 19.0761L11.9092 15.9901C12.1963 15.703 12.1963 15.2376 11.9092 14.9506C11.6222 14.6635 11.1568 14.6635 10.8697 14.9506L7.78368 18.0366C6.07634 19.7439 6.07634 22.5121 7.78368 24.2195C9.49105 25.9268 12.2592 25.9268 13.9665 24.2195C13.9665 24.2195 13.9665 24.2195 13.9665 24.2195L17.0526 21.1334C17.3396 20.8464 17.3396 20.381 17.0526 20.0939C16.7655 19.8069 16.3001 19.8069 16.0131 20.0939L12.927 23.18L12.927 23.18Z",
    fill: "#039855"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.094 17.0494C20.381 17.3364 20.8465 17.3364 21.1335 17.0494L24.2195 13.9633C25.9269 12.256 25.9269 9.48781 24.2195 7.78047C22.5122 6.0731 19.744 6.07309 18.0367 7.78047C18.0367 7.78047 18.0367 7.78047 18.0367 7.78048L14.9506 10.8665C14.6636 11.1535 14.6636 11.619 14.9506 11.906C15.2377 12.1931 15.7031 12.1931 15.9901 11.906L19.0762 8.81997L19.0762 8.81996C20.2094 7.6867 22.0468 7.6867 23.18 8.81997C24.3133 9.95321 24.3133 11.7906 23.18 12.9238L20.094 16.0099C19.8069 16.2969 19.8069 16.7623 20.094 17.0494Z",
    fill: "#039855"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.789 10.7891C11.0761 10.5021 11.0761 10.0367 10.789 9.7496L9.246 8.20657C8.95895 7.91952 8.49355 7.91952 8.2065 8.20657C7.91945 8.49362 7.91945 8.95902 8.2065 9.24607L9.74953 10.7891C10.0366 11.0762 10.502 11.0762 10.789 10.7891Z",
    fill: "#039855"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.789 10.7891C11.0761 10.5021 11.0761 10.0367 10.789 9.7496L9.246 8.20657C8.95895 7.91952 8.49355 7.91952 8.2065 8.20657C7.91945 8.49362 7.91945 8.95902 8.2065 9.24607L9.74953 10.7891C10.0366 11.0762 10.502 11.0762 10.789 10.7891Z",
    fill: "#039855"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.5 12.3267C6.5 12.7327 6.82909 13.0618 7.23504 13.0618H9.41719C9.82314 13.0618 10.1522 12.7327 10.1522 12.3267C10.1522 11.9208 9.82314 11.5917 9.41719 11.5917H7.23504C6.82909 11.5917 6.5 11.9208 6.5 12.3267Z",
    fill: "#039855"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.5 12.3267C6.5 12.7327 6.82909 13.0618 7.23504 13.0618H9.41719C9.82314 13.0618 10.1522 12.7327 10.1522 12.3267C10.1522 11.9208 9.82314 11.5917 9.41719 11.5917H7.23504C6.82909 11.5917 6.5 11.9208 6.5 12.3267Z",
    fill: "#039855"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.3268 10.1522C12.7328 10.1522 13.0619 9.82313 13.0619 9.41718V7.23503C13.0619 6.82908 12.7328 6.49999 12.3268 6.49999C11.9209 6.49999 11.5918 6.82908 11.5918 7.23503V9.41718C11.5918 9.82313 11.9209 10.1522 12.3268 10.1522Z",
    fill: "#039855"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.3268 10.1522C12.7328 10.1522 13.0619 9.82313 13.0619 9.41718V7.23503C13.0619 6.82908 12.7328 6.49999 12.3268 6.49999C11.9209 6.49999 11.5918 6.82908 11.5918 7.23503V9.41718C11.5918 9.82313 11.9209 10.1522 12.3268 10.1522Z",
    fill: "#039855"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.7934 23.7934C24.0805 23.5063 24.0805 23.0409 23.7934 22.7539L22.2504 21.2108C21.9633 20.9238 21.4979 20.9238 21.2109 21.2108C20.9238 21.4979 20.9238 21.9633 21.2109 22.2503L22.7539 23.7934C23.041 24.0804 23.5064 24.0804 23.7934 23.7934Z",
    fill: "#039855"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.7934 23.7934C24.0805 23.5063 24.0805 23.0409 23.7934 22.7539L22.2504 21.2108C21.9633 20.9238 21.4979 20.9238 21.2109 21.2108C20.9238 21.4979 20.9238 21.9633 21.2109 22.2503L22.7539 23.7934C23.041 24.0804 23.5064 24.0804 23.7934 23.7934Z",
    fill: "#039855"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.6733 25.5C20.0792 25.5 20.4083 25.1709 20.4083 24.765V22.5828C20.4083 22.1769 20.0792 21.8478 19.6733 21.8478C19.2673 21.8478 18.9382 22.1769 18.9382 22.5828V24.765C18.9382 25.1709 19.2673 25.5 19.6733 25.5Z",
    fill: "#039855"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.6733 25.5C20.0792 25.5 20.4083 25.1709 20.4083 24.765V22.5828C20.4083 22.1769 20.0792 21.8478 19.6733 21.8478C19.2673 21.8478 18.9382 22.1769 18.9382 22.5828V24.765C18.9382 25.1709 19.2673 25.5 19.6733 25.5Z",
    fill: "#039855"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.8477 19.6733C21.8477 20.0792 22.1767 20.4083 22.5827 20.4083H24.7648C25.1708 20.4083 25.4999 20.0792 25.4999 19.6733C25.4999 19.2673 25.1708 18.9382 24.7648 18.9382H22.5827C22.1767 18.9382 21.8477 19.2673 21.8477 19.6733Z",
    fill: "#039855"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.8477 19.6733C21.8477 20.0792 22.1767 20.4083 22.5827 20.4083H24.7648C25.1708 20.4083 25.4999 20.0792 25.4999 19.6733C25.4999 19.2673 25.1708 18.9382 24.7648 18.9382H22.5827C22.1767 18.9382 21.8477 19.2673 21.8477 19.6733Z",
    fill: "#039855"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrokenLinkWithBg);
export default __webpack_public_path__ + "static/media/broken-link-with-bg.f0ca11b42de0b54e8e5d62dc6ba97473.svg";
export { ForwardRef as ReactComponent };